import { WrapperAmplitudeCompanyPage } from "components/company/v3/WrapperCompany";
import useAmericanBoxes from "components/company/v3/american/boxes/hooks/useAmericanBoxes";
import AmericanPageLayout from "components/company/v3/layouts/AmericanPageLayout";
import { CompanyMenuSlugEnum } from "components/company/v3/menu/enums";
import CompanyPageCta from "components/conversion/CompanyPageCta";
import TwoPassInViewRender from "components/shared/TwoPassInViewRender";
import classNames from "components/ui/classNames";
import useSelfie from "lib/hooks/useSelfie";
import SetHttpStatusCode from "lib/http/SetHttpStatusCode";
import getQueryStringValue from "lib/utils/getQueryStringValue";
import type { NextPage } from "next";
import NotFound from "pages/404";
import { format } from "util";

interface AmericanDefaultPageProps {
  tickerSymbol: string | null;
}

const AmericanDefaultPage: NextPage<AmericanDefaultPageProps> = function AmericanDefaultPage({ tickerSymbol }) {
  const selfie = useSelfie();
  const normalizedTickerSymbol = (tickerSymbol || "").toUpperCase();

  const { orderedMenu } = useAmericanBoxes(normalizedTickerSymbol);

  if (!normalizedTickerSymbol || normalizedTickerSymbol.length > 8 || /^([0-9]+)$/.test(normalizedTickerSymbol)) {
    return (
      <>
        <SetHttpStatusCode httpStatus={404} />
        <NotFound />
      </>
    );
  }

  return (
    <AmericanPageLayout tickerSymbol={normalizedTickerSymbol}>
      <WrapperAmplitudeCompanyPage category="Stocks" tickerSymbol={normalizedTickerSymbol}>
        <div className="flex flex-col space-y-10 pb-6">
          {orderedMenu.map(({ slug, box }, index) => {
            if (
              [CompanyMenuSlugEnum.CARDS, CompanyMenuSlugEnum.ABOUT, CompanyMenuSlugEnum.VALUATION].includes(slug)
            ) {
              return <div key={format("box/%s", slug)}>{box}</div>;
            }
            return (
              <div key={format("box/%s", slug)}>
                <TwoPassInViewRender
                  initialInView={index <= 1}
                  loadingSkeletonClassName={classNames(
                    "relative flex w-full max-w-7xl flex-col gap-6 px-4",
                    "xl:mx-auto xl:px-0",
                  )}
                  tag={slug}
                >
                  {box}
                </TwoPassInViewRender>
              </div>
            );
          })}
          {!selfie?.isPremium && <CompanyPageCta />}
        </div>
      </WrapperAmplitudeCompanyPage>
    </AmericanPageLayout>
  );
};

AmericanDefaultPage.getInitialProps = async ({ query }) => ({
  tickerSymbol: getQueryStringValue(query, "tickerSymbol"),
});

export default AmericanDefaultPage;
